import { render } from "./HealthSleepChart.vue?vue&type=template&id=0159922b"
import script from "./HealthSleepChart.vue?vue&type=script&lang=js"
export * from "./HealthSleepChart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__